import { render, staticRenderFns } from "./ApiUrlChange.vue?vue&type=template&id=44bdf0d0&scoped=true"
import script from "./ApiUrlChange.vue?vue&type=script&lang=js"
export * from "./ApiUrlChange.vue?vue&type=script&lang=js"
import style0 from "./ApiUrlChange.vue?vue&type=style&index=0&id=44bdf0d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bdf0d0",
  null
  
)

export default component.exports